export const PRODUCTS = [
  {
    name: 'Monitoring Platform',
    letter: 'M',
    prefix: 'monitoring_',
    url: process.env.PUBLIC_MONITORING_URL!,
  },
  {
    name: 'Trexty',
    letter: 'T',
    prefix: 'stt_',
    url: process.env.PUBLIC_STT_URL!,
  },
  {
    name: 'Communication Grid',
    letter: 'G',
    prefix: 'scg_',
    url: process.env.PUBLIC_COMMUNICATION_GRID_URL!,
  },
  {
    name: 'Communication App',
    letter: 'A',
    prefix: null,
    url: process.env.PUBLIC_COMMUNICATION_APP_URL!,
  },
  {
    name: 'Cmmndr Center',
    letter: 'C',
    prefix: 'cc_',
    url: process.env.PUBLIC_CENTER_URL!,
  },
] as const;
